import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVeracodeIconLt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 57,
	viewBox: "0 0 56 57",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0.830078L19.5285 54.7855L25.3395 37.8923L12.5789 0.830078H0Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1123_335",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 24,
			y: 0,
			width: 32,
			height: 57,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M43.4211 0.830078L28.3597 44.5864H28.3282L24.1221 56.8301H35.7364L56 0.830078H43.4211Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1123_335)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M56 0.830078H24.1221V56.8301H56V0.830078Z",
				fill: "url(#paint0_linear_1123_335)"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1123_335",
			x1: 35.4776,
			y1: -14.4195,
			x2: 35.4776,
			y2: 95.8751,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00B9FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0065DD"
			})]
		}) })
	]
});
export default SvgVeracodeIconLt;
